import { ListSubheader, TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';

// Search box for the top of a MUI Select menu. Returns an element rather than a
// component so the Select still sees a real ListSubheader as its direct child —
// Select clones its children and would otherwise treat a wrapper as an option.
// The Select needs MenuProps={{ disableAutoFocusItem: true }} or the first
// option takes focus and the box loses every keystroke.
export const renderSelectSearch = (
  value: string,
  onChange: (value: string) => void,
  placeholder = 'Search...'
) => (
  <ListSubheader sx={{ p: 1 }}>
    <TextField
      size="small"
      autoFocus
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        // Select steals keystrokes for its own type-ahead otherwise, but
        // Escape still has to close the menu.
        if (e.key !== 'Escape') e.stopPropagation();
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search fontSize="small" />
          </InputAdornment>
        )
      }}
    />
  </ListSubheader>
);

export default renderSelectSearch;
